import { Suspense } from 'react'
import { Helmet } from 'react-helmet-async'

function PageRendererService({ page }) {
  const element = page.components[0].elements.content[1].content
  return (
    <Suspense fallback={<div>Carregando elementos...</div>}>
      <Helmet>
        <title>{page.title}</title>
        <meta name="description" content={page.title} />
        <meta property="og:title" content={page.title} />
        <meta property="og:description" content={page.title} />
        <meta property="og:image" content={page.title} />
      </Helmet>
      {element}
    </Suspense>
  )
}

export default PageRendererService